import { render, staticRenderFns } from "./ContinueTreatmentDialog.vue?vue&type=template&id=0abb4170&scoped=true&"
import script from "./ContinueTreatmentDialog.vue?vue&type=script&lang=ts&"
export * from "./ContinueTreatmentDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ContinueTreatmentDialog.vue?vue&type=style&index=0&id=0abb4170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb4170",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCheckbox})
